import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Stats from './components/Stats';
import UseCases from './components/UseCases';
import Technology from './components/Technology';
import Advantages from './components/Advantages';
import Team from './components/Team';
import Contact from './components/Contact';
import Accelerator from './components/Accelerator';
import Footer from './components/Footer';
import ParticleBackground from './components/ParticleBackground';
import ScrollToTop from './components/ScrollToTop';
import CookieBanner from './components/CookieBanner';
import AvatarWrapper from './components/AvatarWrapper';
import CookiesPolicy from './pages/CookiesPolicy';
import LegalNotice from './pages/LegalNotice';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import './App.css';

function App() {
  // Inicializar tema al cargar la aplicación
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);
  return (
    <Router basename="/">
      <ScrollToTop />
      <div className="App">
        <ParticleBackground />
        <Navigation />
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <Stats />
              <Technology />
              <UseCases />
              <Advantages />
              <Contact />
            </>
          } />
          <Route path="/nosotros" element={<Team />} />
          <Route path="/cookies" element={<CookiesPolicy />} />
          <Route path="/aviso-legal" element={<LegalNotice />} />
          <Route path="/privacidad" element={<PrivacyPolicy />} />
          <Route path="/terminos" element={<TermsAndConditions />} />
        </Routes>
        <Accelerator />
        <Footer />
        <CookieBanner />
        <AvatarWrapper />
      </div>
    </Router>
  );
}

export default App;
